export default class ResponsiveImageLoader  {

  constructor(options)
  {
    this.options = options;
    this.m_windowScrollPosition = null;
    this.m_windowScrollPositionPlusHeight = null;

    this.PERCENTAGE_FROM_BOTTOM_OF_SCREEN_TRIGGER = 0.1; //0.2 = 20 percent

    this.initialise();
  }

  initialise()
  {
      this.initialiseListeners();


  }

  updateVars()
  {
      var bottomPercentOfScreen = ($(window).height() * this.PERCENTAGE_FROM_BOTTOM_OF_SCREEN_TRIGGER);
      this.m_windowScrollPosition = $(window).scrollTop()
      this.m_windowScrollPositionPlusHeight = this.m_windowScrollPosition  + $(window).height() - bottomPercentOfScreen;
  }

  initialiseListeners()
  {
      //Note the page loaded event comes from the 'loading-screen' class
    $(window).scroll(() => this.onWindowScroll());
    $(window).on("resize", () => this.onWindowResized());
    $("body").on("check-on-screen-triggers",() => this.onBodyCheckTriggersEvent())
  }

  onBodyCheckTriggersEvent()
  {
      this.triggerItemsThatAreAboveOrInViewport();
  }

  onPageLoaded()
  {
      this.triggerItemsThatAreAboveOrInViewport();
  }

  onWindowResized()
  {
      this.triggerItemsThatAreAboveOrInViewport();
  }

  onWindowScroll()
  {
      this.triggerItemsThatAreAboveOrInViewport();
  }




  triggerItemsThatAreAboveOrInViewport()
  {

      this.updateVars();
      var context = this;
    //   $("[class^='-trigger-']:not(.-triggered),[class*=' -trigger-']:not(.-triggered)").each(function()
      
      $(".-trigger-me:not(.-triggered)").each(function()
      {
          var $this = $(this);
          if($this.hasClass("-bottom-trigger") && !context.isItemsBottomOnOrAboveScreen($this))
          {
              return;
          }
          else if(!context.isItemsTopOnOrAboveScreen($this))
          {
              return;

          }

          $this.addClass("-triggered");
      });

      $("video.-trigger-me-play-video:not(.-video-triggered)").each(function()
      {
          var $this = $(this);
          if($this.hasClass("-bottom-trigger") && !context.isItemsBottomOnOrAboveScreen($this))
          {
              return;
          }
          else if(!context.isItemsTopOnOrAboveScreen($this))
          {
              return;

          }

          $this.trigger("play");


          $this.addClass("-video-triggered");
      });

      
  }


  isItemsTopOnOrAboveScreen(_$element)
  {
      var itemScreenPosition = _$element.offset().top;
      var bIsItemOnScreen = this.m_windowScrollPositionPlusHeight >= itemScreenPosition;
      return bIsItemOnScreen;
  }

  isItemsBottomOnOrAboveScreen(_$element)
  {
      var itemScreenPosition = _$element.offset().top + _$element.height();
      var bIsItemOnScreen = this.m_windowScrollPositionPlusHeight >= itemScreenPosition;
      return bIsItemOnScreen;
  }




}



/** WEBPACK FOOTER **
 ** ./system/on-screen-item-toggler.js
 **/